import React from 'react';
import { useQuestionStore } from '../QuestionProvider';
import styled from './index.module.scss';
import { QStatusEnum } from '@/components/AppreciationDay/index.d';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import { textLang } from '../../textLang';
import EditorImg from 'lowcode/components/EditorImg';
import EcoImg from 'eco-design/base/eco-img';

interface QuestionBannerProps {
    showRules: () => void;
    background: {
        image: string;
        mobileImage: string;
    };
}

const defaultImage = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1730796539339/20241104-174634.jpeg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1730796539339/20241104-174634.jpeg',
};

const QuestionBanner: React.FC<QuestionBannerProps> = ({ showRules, background }) => {
    const { isMobile, useRouter } = useGlobal();
    const { questionInfo, scenario } = useQuestionStore();
    const { locale } = useRouter();
    const lang = textLang[locale as string] || textLang.us;

    const getBannerSrc = () => {
        if (!scenario) {
            return require(`@publicLocal/appreciation-day/${isMobile ? 'h5' : 'pc'}/banner-question.png`);
        }
        if (scenario === 'active_eu') {
            if (!isMobile) {
                return '';
            }
            return '';
        }
        return '';
    };

    if (!questionInfo) return <></>;

    return (
        <div className={`${styled.question_banner} ${scenario ? scenario : ''}`}>
            <h5 className="title">{questionInfo.campaignName}</h5>
            <p className="subtitle">{questionInfo.subTitle}</p>
            <p className="subtitle rules" onClick={showRules}>
                {lang.rules}
            </p>
            <div className="banner">
                <EcoImg pc={background.image || defaultImage.pc} h5={background.mobileImage || defaultImage.h5} />
                {/* <div className="text_box">
                    {questionInfo?.answerStatus === QStatusEnum.FIRST ||
                    questionInfo?.answerStatus === QStatusEnum.NONE ||
                    !questionInfo.questionGroupId ? null : (
                        <div className="score">
                            <p className="title">{lang.rewards}</p>
                            <div className="score_box">
                                <div className="item">
                                    <p className="num">{questionInfo.rewardTotalPoints || 0}</p>
                                    <p>{lang.ecoCredits}</p>
                                </div>
                                <div className="line"></div>
                                <div className="item">
                                    <p className="num">0</p>
                                    <p>{t('question.coupons')}</p>
                                </div>
                            </div>
                            {questionInfo?.answerStatus === QStatusEnum.NEXT && <p className="desc">{lang.continue}</p>}
                        </div>
                    )}
                </div> */}
            </div>
            {questionInfo.ruleDescription && !questionInfo?.questionGroupId && (
                <div className="tips">
                    <p>{questionInfo.ruleDescription}</p>
                </div>
            )}
            {questionInfo?.questionGroupId && (
                <div className="tips">
                    <p>
                        {lang.rewards}
                        <span className="points">{questionInfo.rewardTotalPoints || 0}</span>
                        {lang.ecoCredits}
                    </p>
                </div>
            )}
        </div>
    );
};

export default QuestionBanner;
